import { MouseEventHandler } from 'react';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { ReservedExpander } from './atoms';

type ExpanderProps = {
  isCollapsed: boolean;
  onClick: MouseEventHandler<HTMLDivElement>;
  size?: IconSize | number;
  controls: string;
  ariaLabel: string;
};

export const Expander = ({
  controls,
  onClick,
  isCollapsed,
  size = 18,
  ariaLabel,
}: ExpanderProps) => {
  const iconName = isCollapsed ? IconName.CHEVRON_DOWN : IconName.CHEVRON_UP;
  return (
    <ReservedExpander
      onClick={onClick}
      $size={size}
      aria-expanded={!isCollapsed}
      aria-label={ariaLabel}
      aria-controls={controls}
      role="button"
    >
      <Icon iconName={iconName} iconSize={size} />
    </ReservedExpander>
  );
};
